import { callAxios, dev_console, isSuccess, whoAmI } from "../../../../../Common/ts/commonTools";
import { defaultApiReaponseInterface } from "../../../../../Common/interface/Common.interface";
import { mainREST_Interface } from "../static/interface/wrokRequiredNotificationDataREST.interface";
import { GC_TIME, STALE_TIME } from "../../../../../Common/ts/const";
import useCustomQuery from "../../../../../Common/hooks/useCustomQuery";

const useMainREST = (enabled: boolean = true) => {
    const isAbleToRequest = () => {
        let result: boolean = false;

        if(whoAmI.isCustomer()){
            result = true;
        }

        return result;
    }

    const {
        data: mainData = null,
        error: mainError,
        isLoading: mainIsLoading,
        refetch: mainRefetch
    } = useCustomQuery({
        queryKey: ["useMainREST"],
        queryFn: callMainData,
        enabled: () => enabled && isAbleToRequest(),
        select: (response) => {
            if(response){
                const data: defaultApiReaponseInterface<mainREST_Interface> = response.data;

                if(isSuccess(response)){
                    return data.result;
                }else{
                    return null;
                }
            }else{
                return null;
            }
        },
    })

    async function callMainData(){
        const main_url = "api/v3/oops/main";

        const response = await callAxios.api({
            url: main_url,
            method: "get",
        })

        dev_console.log(main_url);
        dev_console.log(response);

        return response;
    }
    
    return({
        mainData,
        mainError,
        mainIsLoading,
        mainRefetch,
    })
}

export default useMainREST;
